import { render, staticRenderFns } from "./FileDocument.vue?vue&type=template&id=f7968578&"
import script from "./FileDocument.vue?vue&type=script&lang=js&"
export * from "./FileDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports